import type { BasePlaceEntity, Place } from '@placer-ui/types';
import { getPermissions } from 'core/flow-control';
import { isRestrictedArea } from 'core/services/report-entities-service/report-entities-service';

export const isAddressType = (poi: Pick<Place, 'provider_data'>) => {
    return poi.provider_data?.entity_type === 'address';
};

export const getPlacePoiProvider = (poi: Pick<Place, 'provider_data'>) => {
    return (poi.provider_data && poi.provider_data.provider) || 'placer';
};

export const isPlaceANonPlacerPoi = (poi: Pick<Place, 'provider_data'>) => {
    return getPlacePoiProvider(poi) !== 'placer';
};

export const getIsRestrictedPOI = (poi: BasePlaceEntity) => {
    const { restrict_pois_if_part_of_critical } = getPermissions();

    return restrict_pois_if_part_of_critical && isRestrictedArea(poi);
};
